import { render, staticRenderFns } from "./cpt-dataV-decoration-option.vue?vue&type=template&id=74c0e24b&scoped=true"
import script from "./cpt-dataV-decoration-option.vue?vue&type=script&lang=js"
export * from "./cpt-dataV-decoration-option.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c0e24b",
  null
  
)

export default component.exports